import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { AboutComponent } from 'src/app/components/dialogs/about/about.component';
import { AddCommentComponent } from 'src/app/components/dialogs/add-comment/add-comment.component';
import { DialogAddCommentData } from 'src/app/components/dialogs/add-comment/models/dialog-add-comment-data';
import { AddFileComponent } from 'src/app/components/dialogs/add-file/add-file.component';
import { DialogAddFileData } from 'src/app/components/dialogs/add-file/models/dialog-add-file-data';
import { AddFolderComponent } from 'src/app/components/dialogs/add-folder/add-folder.component';
import { DialogAddFolderData } from 'src/app/components/dialogs/add-folder/models/dialog-add-folder-data';
import { AddReminderComponent } from 'src/app/components/dialogs/add-reminder/add-reminder.component';
import { ContactsComponent } from 'src/app/components/dialogs/contacts/contacts.component';
import { ContactDataType } from 'src/app/components/dialogs/contacts/models/contact-data-type';
import { DialogContactsData } from 'src/app/components/dialogs/contacts/models/dialog-contacts-data';
import { DeleteCommentComponent } from 'src/app/components/dialogs/delete-comment/delete-comment.component';
import { DeleteDocumentComponent } from 'src/app/components/dialogs/delete-document/delete-document.component';
import { DeleteFolderConfirmationComponent } from 'src/app/components/dialogs/delete-folder/delete-folder-confirmation.component';
import { DeletePredefinedFilterComponent } from 'src/app/components/dialogs/delete-predefined-filter/delete-predefined-filter.component';
import { DraftEmailComponent } from 'src/app/components/dialogs/draft-email/draft-email.component';
import { DuplicateFolderComponent } from 'src/app/components/dialogs/duplicate-folder/duplicate-folder.component';
import { DialogDuplicateData } from 'src/app/components/dialogs/duplicate-folder/models/dialog-duplicate-data';
import { EditCommentComponent } from 'src/app/components/dialogs/edit-comment/edit-comment.component';
import { EditLinkAttributeComponent } from 'src/app/components/dialogs/edit-link-attribute/edit-link-attribute.component';
import { ForceConnectionComponent } from 'src/app/components/dialogs/force-connection/force-connection.component';
import { DialogForceConnectionData } from 'src/app/components/dialogs/force-connection/models/dialog-force-connection-data';
import { MergeConfirmationComponent } from 'src/app/components/dialogs/merge-confirmation/merge-confirmation.component';
import { MergeComponent } from 'src/app/components/dialogs/merge/merge.component';
import { DialogMergeData } from 'src/app/components/dialogs/merge/models/dialog-merge-data';
import { DialogDataMoveToBox, MoveToBoxComponent } from 'src/app/components/dialogs/move-to-box/move-to-box.component';
import { DialogProfileSettingsData } from 'src/app/components/dialogs/profile-settings/models/dialog-profile-settings-data';
import { ProfileSettingsComponent } from 'src/app/components/dialogs/profile-settings/profile-settings.component';
import { DialogSavePredefinedFilterData, PredefinedFilterSaveType } from 'src/app/components/dialogs/save-predefined-filter/models/dialog-save-predefined-filter-data';
import { SavePredefinedFilterComponent } from 'src/app/components/dialogs/save-predefined-filter/save-predefined-filter.component';
import { DialogSaveTchatData } from 'src/app/components/dialogs/save-tchat/models/dialog-save-tchat-data';
import { SaveTchatComponent } from 'src/app/components/dialogs/save-tchat/save-tchat.component';
import { DialogSearchData } from 'src/app/components/dialogs/search/models/dialog-search-data';
import { SearchComponent } from 'src/app/components/dialogs/search/search.component';
import { DialogSelectFolderFilesData } from 'src/app/components/dialogs/select-folder-files/models/dialog-select-folder-files-data';
import { SelectFolderFilesComponent } from 'src/app/components/dialogs/select-folder-files/select-folder-files.component';
import { DialogSendEmailData } from 'src/app/components/dialogs/send-email/models/dialog-send-email-data';
import { SendEmailComponent } from 'src/app/components/dialogs/send-email/send-email.component';
import { DialogSendSmsData } from 'src/app/components/dialogs/send-sms/models/dialog-send-sms-data';
import { SendSmsComponent } from 'src/app/components/dialogs/send-sms/send-sms.component';
import { DialogSessionTimeoutData } from 'src/app/components/dialogs/session-timeout/models/dialog-session-timeout-data';
import { SessionTimeoutComponent } from 'src/app/components/dialogs/session-timeout/session-timeout.component';
import { SetInStandByStateData } from 'src/app/components/dialogs/set-in-stand-by-state/models/set-in-stand-by-state-data';
import { SetInStandByStateComponent } from 'src/app/components/dialogs/set-in-stand-by-state/set-in-stand-by-state.component';
import { SupervisionComponent } from 'src/app/components/dialogs/supervision/supervision.component';
import { DialogUnlockFolderRequestData } from 'src/app/components/dialogs/unlock-folder-request/models/dialog-unlock-folder-request-data';
import { UnlockFolderRequestComponent } from 'src/app/components/dialogs/unlock-folder-request/unlock-folder-request.component';
import { DialogUnlockFolderResponseData } from 'src/app/components/dialogs/unlock-folder-response/models/dialog-unlock-folder-response-data';
import { UnlockFolderResponseComponent } from 'src/app/components/dialogs/unlock-folder-response/unlock-folder-response.component';
import { FolderDraftEmailsChangeEvent } from 'src/app/models/events/folder-draft-emails-change-event';
import { PredefinedFilter } from 'src/app/models/predefined-filter';
import { Attachment } from 'src/app/models/server/attachment';
import { CommentInput } from 'src/app/models/server/comment-input';
import { DraftEmail } from 'src/app/models/server/draft-email';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { Folder } from 'src/app/models/server/folder';
import { FolderDocument } from 'src/app/models/server/folder-document';
import { Reminder } from 'src/app/models/server/reminder';
import { View } from 'src/app/models/server/view';
import { FolderDraftEmailsStateService } from '../state/folder-draft-emails-state.service';

/**
 * Service utilisé pour gérer l'affichage des boites de dialogue.
 */
@Injectable({
    providedIn: 'root',
})
export class DialogService {
    /**
     * Constructeur.
     * @param dialog
     */
    constructor(
        public dialog: MatDialog,
        public folderDraftEmailsStateService: FolderDraftEmailsStateService
    ) {}

    /**
     * Ferme toutes les boites de dialogue ouvertes.
     */
    public closeAll() {
        this.dialog.closeAll();
    }

    /**
     * Ouvre la boite de dialogue permettant de sélectionner la bannette de destination d'un changement de bannette.
     * @param boxId Identifiant de la bannette d'origine.
     * @returns La nouvelle bannette.
     */
    public openMoveToBox(boxId: string): Observable<DialogDataMoveToBox> {
        const dialogRef = this.dialog.open(MoveToBoxComponent, {
            data: { boxId },
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de sélectionner le dossier de destination d'une fusion de dossiers.
     * @param view: Vue des dossiers.
     * @param sourceFolders Liste des dossier sources.
     * @returns Id du dossier de destination.
     */
    public openMerge(view: View, sourceFolders: Folder[]): Observable<DialogMergeData> {
        const dialogRef = this.dialog.open(MergeComponent, {
            data: new DialogMergeData(view, sourceFolders, null),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de définir le nombre de copies d'une duplication de dossiers.
     * @param sourceFolders Liste des dossier sources.
     * @returns Données contenant la liste des dossiers sources et le nombre de copies.
     */
    public openDuplicate(sourceFolders: Folder[]): Observable<DialogDuplicateData> {
        const dialogRef = this.dialog.open(DuplicateFolderComponent, {
            data: { sourceFolders: sourceFolders, duplicateCount: 1 },
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de confirmation de suppression de dossiers.
     * @param folders Instances des dossiers à supprimer.
     * @returns Retourne un boolean indiquant si l'utilisateur a valider ou annuler la suppression.
     */
    public openDeleteFolder(folders: Folder[]): Observable<boolean> {
        const dialogRef = this.dialog.open(DeleteFolderConfirmationComponent, {
            data: { folders: folders },
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant la saisie d'un commentaire.
     * @returns retourne le texte du commentaires.
     */
    public openAddComment(): Observable<DialogAddCommentData> {
        const dialogRef = this.dialog.open(AddCommentComponent, {
            data: new DialogAddCommentData(),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant d'enregistrer un filtre.
     * @returns retourne le texte du commentaires.
     */
    public openSavePredefinedFilter(saveType: PredefinedFilterSaveType, predefinedFilter: PredefinedFilter): Observable<PredefinedFilter> {
        const dialogRef = this.dialog.open(SavePredefinedFilterComponent, {
            data: new DialogSavePredefinedFilterData(saveType, predefinedFilter),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    public openDeletePredefinedFilter(predefinedFilter: PredefinedFilter): Observable<boolean> {
        const dialogRef = this.dialog.open(DeletePredefinedFilterComponent, {
            data: predefinedFilter,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant la modification d'un commentaire.
     * @returns retourne le texte du commentaires.
     */
    public openEditComment(comment: CommentInput): Observable<DialogAddCommentData> {
        const dialogRef = this.dialog.open(EditCommentComponent, {
            data: new DialogAddCommentData(comment.text),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    public openDeleteComment(comment: CommentInput): Observable<boolean> {
        const dialogRef = this.dialog.open(DeleteCommentComponent, {
            data: comment,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant la saisie d'un rappel.
     * @folder: Dossier pour lequel on veut créer un rappel.
     * @returns retourne les informations du rappel.
     */
    public openAddReminder(folder: Folder): Observable<Reminder> {
        let reminder = new Reminder();
        reminder.viewId = folder.viewId;

        const dialogRef = this.dialog.open(AddReminderComponent, {
            data: reminder,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant l'édition d'un rappel.
     * @returns retourne les informations du rappel.
     */
    public openEditReminder(reminder: Reminder): Observable<Reminder> {
        const dialogRef = this.dialog.open(AddReminderComponent, {
            data: reminder,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de sélectionner le fichier à ajouter.
     * @param folderViewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Identifiant du dossier.
     */
    public openAddFile(folderViewId: number, folderId: string): Observable<FolderDocument> {
        const dialogRef = this.dialog.open(AddFileComponent, {
            data: new DialogAddFileData(folderViewId, folderId),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed().pipe(
            map((x: FolderDocument) => {
                if (x) {
                    x.viewId = folderViewId;
                    return x;
                } else {
                    return null;
                }
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant de saisir les informations de l'e-mail à envoyer.
     * @param folderViewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Identifiant du dossier.
     */
    public openSendEmail(folderViewId: number, folderId: string): Observable<FolderDocument> {
        const dialogRef = this.dialog.open(SendEmailComponent, {
            data: new DialogSendEmailData(folderViewId, folderId),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed().pipe(
            map((x) => {
                if (x) {
                    if (x instanceof FolderDocument) {
                        x.viewId = folderViewId;
                        return x;
                    } else if (x instanceof DraftEmail) {
                        this.folderDraftEmailsStateService.updateFolderDraftEmailChange(new FolderDraftEmailsChangeEvent(x.folderId, true));
                        return null;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant de saisir les informations de l'e-mail de réponse.
     * @param folderViewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Identifiant du dossier.
     * @param document Document auquel répondre.
     */
    public openReplyToEmail(folderViewId: number, folderId: string, document: FolderDocument): Observable<FolderDocument> {
        const dialogRef = this.dialog.open(SendEmailComponent, {
            data: new DialogSendEmailData(folderViewId, folderId, document, true),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed().pipe(
            map((x) => {
                if (x) {
                    if (x instanceof FolderDocument) {
                        x.viewId = folderViewId;
                        return x;
                    } else if (x instanceof DraftEmail) {
                        this.folderDraftEmailsStateService.updateFolderDraftEmailChange(new FolderDraftEmailsChangeEvent(x.folderId, true));
                        return null;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant de saisir les informations de l'e-mail à renvoyer.
     * @param folderViewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Identifiant du dossier.
     * @param document Document auquel répondre.
     */
    public openResendEmail(folderViewId: number, folderId: string, document: FolderDocument): Observable<FolderDocument> {
        const dialogRef = this.dialog.open(SendEmailComponent, {
            data: new DialogSendEmailData(folderViewId, folderId, document, false),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed().pipe(
            map((x) => {
                if (x) {
                    if (x instanceof FolderDocument) {
                        x.viewId = folderViewId;
                        return x;
                    } else if (x instanceof DraftEmail) {
                        this.folderDraftEmailsStateService.updateFolderDraftEmailChange(new FolderDraftEmailsChangeEvent(x.folderId, true));
                        return null;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant d'afficher un brouillon de mail pour l'envoyer.
     * @param draftEmail Instance du brouillon de mail.
     */
    public openDraftEmail(draftEmail: DraftEmail): Observable<any> {
        const dialogRef = this.dialog.open(DraftEmailComponent, {
            data: {
                dialogTitle: 'Brouillon de mail',
                draftEmail: draftEmail,
            },
            panelClass: 'empty-dialog',
            disableClose: true,
        });

        return dialogRef.afterClosed().pipe(
            map((x) => {
                return x;
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant d'afficher un mail généré automatiquement pour l'envoyer.
     * @param draftEmail Instance du brouillon de mail.
     */
    public openAutoGeneratedEmail(draftEmail: DraftEmail): Observable<any> {
        const dialogRef = this.dialog.open(DraftEmailComponent, {
            data: {
                dialogTitle: "Confirmation d'envoi d'un email généré par le workflow",
                draftEmail: draftEmail,
            },
            panelClass: 'empty-dialog',
            disableClose: true,
        });

        return dialogRef.afterClosed().pipe(
            map((x) => {
                return x;
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant de saisir les informations du SMS à envoyer.
     * @param folderViewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Identifiant du dossier.
     */
    public openSendSms(folderViewId: number, folderId: string): Observable<FolderDocument> {
        const dialogRef = this.dialog.open(SendSmsComponent, {
            data: new DialogSendSmsData(folderViewId, folderId),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed().pipe(
            map((x) => {
                if (x) {
                    if (x instanceof FolderDocument) {
                        x.viewId = folderViewId;
                        return x;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            })
        );
    }

    /**
     * Ouvre la boite de dialogue permettant de saisir les informations du dossier à créer.
     * @param folderId Identifiant du dossier.
     */
    public openAddFolder(viewType: ViewType): Observable<DialogAddFolderData> {
        const dialogRef = this.dialog.open(AddFolderComponent, {
            data: new DialogAddFolderData(viewType, {} as Folder),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant d'éditer un attribut de type lien.
     * @param folderId Identifiant du dossier.
     */
    openEditLinkAttribute(link: string): Observable<string> {
        const dialogRef = this.dialog.open(EditLinkAttributeComponent, {
            data: link,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue 'A propos'.
     */
    public openAbout(): Observable<boolean> {
        const dialogRef = this.dialog.open(AboutComponent, {
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue d'expiration de session.
     * @param sessionTimeout : Date d'expiration de la session.
     * @param sessionNotificationDelay :  Delai (en secondes) avant l'expiration de la session pour afficher la notification à l'utilisateur.
     */
    public openSessionTimeout(sessionTimeout: Date, sessionNotificationDelay: number): Observable<boolean> {
        const dialogRef = this.dialog.open(SessionTimeoutComponent, {
            data: new DialogSessionTimeoutData(sessionTimeout, sessionNotificationDelay),
            panelClass: 'empty-dialog',
            ariaModal: true,
            disableClose: true,
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de sélectionner des contacts.
     */
    public openContacts(dataType: ContactDataType): Observable<DialogContactsData> {
        const dialogRef = this.dialog.open(ContactsComponent, {
            data: new DialogContactsData(dataType),
            width: '1000px',
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de confirmation de fusion de dossiers.
     * @param sourceFolders dossiers sources.
     * @param targetFolder dossier cible.
     * @returns Retourne un boolean indiquant si l'utilisateur a valider ou annuler la fusion.
     */
    public openConfirmMerge(sourceFolders: Folder[], targetFolder: Folder): Observable<boolean> {
        const dialogRef = this.dialog.open(MergeConfirmationComponent, {
            data: { sourceFolders, targetFolder },
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de sauvegarder une conversation t'chat.
     */
    public openSaveTchat(): Observable<DialogSaveTchatData> {
        const dialogRef = this.dialog.open(SaveTchatComponent, {
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de placer un dossier en stand-by.
     * @returns retourne les informations du mode stand-by.
     */
    public openSetInStandByState(defautDuration: number): Observable<SetInStandByStateData> {
        const dialogRef = this.dialog.open(SetInStandByStateComponent, {
            data: new SetInStandByStateData(defautDuration),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de supervision.
     */
    public openSupervision(): Observable<boolean> {
        const dialogRef = this.dialog.open(SupervisionComponent, {
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue du profil utilisateur.
     */
    public openProfileSettings(): Observable<DialogProfileSettingsData> {
        const dialogRef = this.dialog.open(ProfileSettingsComponent, {
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue permettant de sélectionner les fichiers d'un dossier
     */
    public openSelectFolderFiles(folderFiles: Attachment[]): Observable<Attachment[]> {
        const dialogRef = this.dialog.open(SelectFolderFilesComponent, {
            data: new DialogSelectFolderFilesData(folderFiles),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de confirmation d'une demande de déverrouillage d'un dossier.
     * @returns retourne la réponse à la demande de déverrouillage d'un dossier.
     */
    public openUnlockFolderRequest(userName: string, folderName: string, delay: number): Observable<boolean> {
        const dialogRef = this.dialog.open(UnlockFolderRequestComponent, {
            data: new DialogUnlockFolderRequestData(userName, folderName, delay),
            panelClass: 'empty-dialog',
            disableClose: true,
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de réponse à une demande de déverrouillage d'un dossier.
     */
    public openUnlockFolderResponse(userName: string, folderName: string, accept: boolean) {
        const dialogRef = this.dialog.open(UnlockFolderResponseComponent, {
            data: new DialogUnlockFolderResponseData(userName, folderName, accept),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de confirmation de suppression d'un document d'un dossier.
     */
    public openConfirmDeleteDocument(document: FolderDocument) {
        const dialogRef = this.dialog.open(DeleteDocumentComponent, {
            data: document,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de confirmation de connexion forcée.
     * @param login login de l'utilisateur.
     */
    public openForceConnection(login: string) {
        const dialogRef = this.dialog.open(ForceConnectionComponent, {
            data: new DialogForceConnectionData(login),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     *
     * @returns
     */

    /**
     * Ouvre la boite de dialogue de recherche.
     * @param searchNameTitle Nom de la recherche
     * @returns retourne le texte à rechercher.
     */
    public openSearch(searchNameTitle: string, searchText: string): Observable<DialogSearchData> {
        const dialogRef = this.dialog.open(SearchComponent, {
            data: new DialogSearchData(searchNameTitle, searchText),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }
}
